import { Row, Col } from "./Flexbox";
import Text from "./Text";
import { Input, SelectField, fieldRow } from "./FormField";
import { useWatch } from "react-hook-form";

const PRODUCTION_OPTIONS = {
    prensaCajaItems: [
        { value: "40F746COL", label: "40 F74 6COL" },
        { value: "40F746CD", label: "40 F74 6CD" },
        { value: "40F742COL", label: "40 F74 2COL" },
        { value: "40F701COL", label: "40 F70 1COL" },
        { value: "40F744COL", label: "40 F74 4COL" },
        { value: "40F522COL", label: "40 F52 2COL" }
    ],

    prensaFlexoItems: [
        { value: "20FNPTR", label: "20 FLEXONPTR" },
        { value: "20F01COL", label: "20 FLEXO1COL" },
        { value: "20F4COL", label: "20 FLEXO4COL" },
        { value: "20F06MF", label: "20 FLEXO6MF" },
        { value: "HP6000", label: "HP6000" }
    ],

    camaBlancoItems: [
        { value: "Plasta", label: "Plasta" },
        { value: "Registro", label: "Registro" }
    ],

    barnizItems: [
        { value: "AcrBrill", label: "Acrílico brillante" },
        { value: "AcrMate", label: "Acrílico mate" },
        { value: "Termo", label: "Termosellante" }
    ],

    barnizItems2: [
        { value: "AcrBrill", label: "UV brillante" },
        { value: "AcrMate", label: "UV mate" },
        { value: "Termo", label: "Manga" }
    ],

    aplicBarnizItems: [
        { value: "Plasta", label: "Plasta" },
        { value: "Registro", label: "Registro" }
    ],

    carasBarnizItems: [
        { value: "Frente", label: "Frente" },
        { value: "Vuelta", label: "Vuelta" }
    ],

    mangasItems: [
        { value: "Corte", label: "Corte"},
        { value: "Sellado", label: "Sellado"}
    ]
}

const ProductionParams = ({theme, control}) => {

    const format = useWatch({control, name: "format"});
    const activeProcesses = useWatch({control, name: "activeProcesses"}) || [];

    return (
        <Col style={{width: '100%', alignItems: 'start', marginTop: 64}}>
            <Text size={15} color={theme.Black} weight={"extrabold"}>Parámetros de producción</Text>
            <Col style={{width: '100%', justifyContent: 'space-between'}}>
                <Row style={{...fieldRow, width: '100%', marginTop: 16}}>
                    <SelectField theme={theme} control={control} name="press" label = "Prensa" options={format === "Flexo" ? PRODUCTION_OPTIONS.prensaFlexoItems : PRODUCTION_OPTIONS.prensaCajaItems}/>
                    {activeProcesses.includes("inkMix") && (
                        <Input theme={theme} control={control} name= "inkMixTxt" label = "Preparación tinta"/>
                    )}
                    {activeProcesses.includes("clickCharge1") && (
                        <Input theme={theme} control={control} name="clickChargeTxt1" label="Cálculo clicks 1"/>
                    )}
                    {activeProcesses.includes("clickCharge2") && (
                        <Input theme={theme} control={control} name="clickChargeTxt2" label="Cálculo clicks 2"/>
                    )}
                    {format !== "Plana" && <Input theme={theme} control={control} name= "additionalSub" label = "Sustrato adicional"/>}
                    <Input theme={theme} control={control} name= "splice" label = "Empalme"/>
                    <Input theme={theme} control={control} name= "tradePrint" label = "Maquila"/>
                    <SelectField theme={theme} control={control} name="whiteUnderprint" label = "Cama de blanco" options={PRODUCTION_OPTIONS.camaBlancoItems}/>
                </Row>
                <Row style={{...fieldRow, width: '100%', marginTop: 16}}>
                    {format === "Flexo" && (
                        <>
                            {activeProcesses.includes("chemicals") && (
                                <Input theme={theme} control={control} name="chemicalsTxt" label="Químicos"/>
                            )}
                            <SelectField theme={theme} control={control} name="sleeves" label = "Mangas" options={PRODUCTION_OPTIONS.mangasItems}/>
                            <Input theme={theme} control={control} name= "around" label = "Alrededor"/>
                            <Input theme={theme} control={control} name= "across" label = "Al paso"/>
                        </>
                    )}
                    {activeProcesses.includes("design") && (
                        <Input theme={theme} control={control} name= "design" label = "Diseño"/>
                    )}
                    {activeProcesses.includes("ctp") && (
                        <Input theme={theme} control={control} name= "ctpTxt" label = "CTP"/>
                    )} 
                    {activeProcesses.includes("cut") && (
                        <Input theme={theme} control={control} name= "cutTxt" label = "Corte"/>
                    )} 
                    {format !== "Caja" && activeProcesses.includes("shapeCut") && (
                        <Input theme={theme} control={control} name= "shapeCutTxt" label = "Corte figura"/> 
                    )} 
                    {activeProcesses.includes("positive") && (
                        <Input theme={theme} control={control} name= "positiveTxt" label = "Positivo"/>
                    )} 
                </Row>
                <Row style={{...fieldRow, width: '100%', marginTop: 16}}>
                    <SelectField theme={theme} control={control} name="coating.line" label = "Barniz en línea" options={format !== "Flexo" ? PRODUCTION_OPTIONS.barnizItems : PRODUCTION_OPTIONS.barnizItems2} multiple/>
                    <SelectField theme={theme} control={control} name="coating.application" label = "Aplicación barniz" options={PRODUCTION_OPTIONS.aplicBarnizItems} multiple/>
                    <SelectField theme={theme} control={control} name="coating.faces" label = "Caras con barniz" options={PRODUCTION_OPTIONS.carasBarnizItems} multiple/>
                </Row>
            </Col>
        </Col>
    )
}

export default ProductionParams;